import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "../../services/api-client.service";
import { IVerksamhetshandelseRequest, IVerksamhetshandelseResponse } from "./contracts/verksamhetshandelse";

@Injectable({
    providedIn: "root"
})
export class VisningsloggService {
    private readonly http = inject(ApiClientService);

    private readonly url: string;

    constructor() {
        this.url = "visningslogg/";
    }

    createOrUpdateVisningslogg(request: IVerksamhetshandelseRequest): Observable<IVerksamhetshandelseResponse[]> {
        return this.http.post<IVerksamhetshandelseRequest, IVerksamhetshandelseResponse[]>(this.url, request);
    }
}
